export interface IEmailConfiguration {
  emailId: string;
  usersToSend?: string[];
  from: string;
  displayName: string;
  category: string;
  enabledAgencies?: string[];
  disabledAgencies?: string[];
}

export interface IEmailsLogs {
  date: number;
  emailId: string;
  displayName: string;
  logId: string;
  usersSent: string[];
}

export const initialEmailConfiguration: IEmailConfiguration = {
  emailId: '',
  from: '',
  displayName: '',
  category: ''
}

export interface IEmailsLogsRequest {
  sort: Array<{ [key: string]: 'asc' | 'desc' }>;
  page: number;
  size: number;
}

export const initialEmailsLogsRequest: IEmailsLogsRequest = {
  sort: [{ date: 'desc' }],
  page: 0,
  size: 10
};

export interface IEmailsServiceResponse {
  total: number,
  results: Array<IEmailConfiguration | IEmailsLogs>
}
